<template>
  <div>
    哈哈，你个逗比~~
    {{count}}
    <input type="text" class="search">

  </div>

</template>

<script>
export default {
    name: 'HelloWorld',
    computed:{
        count:function(){
            return this.$store.state.app.count;
        }
    },
    data () {
        return {
            msg: 'Welcome to Your Vue.js App'
        };
    },
    created(){
        _post('/insurance-web/productList/productList',{
            'typeId': 1,
            'page': 1,
            'pageSize': 10,
            'showType': 1
        }).then(res => {
            // console.log(res);
        });
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .search{
    width: 750px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue